module.exports = __webpack_public_path__ + "static/media/tip.f34a4fa8.png";